const logicData = {
    invoice: [
        // Calculates Net Sales Amount on the Line from the price and quantity on Invoice Line 
        {
            id: 'calcNetSalesAmountBeforeDiscount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['netSalesPrice', 'itemQuantity'],
            targetField: 'netSalesAmountBeforeDiscount'
        },
        // The money the line discount takes off, rounded where it is computed
        {
            id: 'calcLineDiscountAmount',
            logicType: 'calcFields',
            operationType: 'sub.discount',
            subEntity: 'lines',
            typeField: 'discountType',
            valueField: 'discountValue',
            baseField: 'netSalesAmountBeforeDiscount',
            targetField: 'discountAmount',
            decimals: 2
        },
        // netSalesAmount stays the line net that every later step reads -- it is
        // now the amount after any line discount, so a discount reaches the VAT
        // groups and the totals without either of them knowing it exists
        {
            id: 'calcNetSalesAmount',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'subtract',
            subEntity: 'lines',
            fieldsToOperate: ['netSalesAmountBeforeDiscount', 'discountAmount'],
            targetField: 'netSalesAmount'
        },
        // The subtotal: every line's net, after any line discount. This is what
        // the document discount is a percentage of, which is what makes the two
        // levels compose rather than both applying to the list price
        {
            id: 'calcTotalNetSalesAmountBeforeDiscount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'netSalesAmount',
            targetField: 'totalNetSalesAmountBeforeDiscount'
        },
        // The money the document discount takes off, rounded where it is computed
        {
            id: 'calcDocumentDiscountAmount',
            logicType: 'calcFields',
            operationType: 'header.discount',
            typeField: 'documentDiscountType',
            valueField: 'documentDiscountValue',
            baseField: 'totalNetSalesAmountBeforeDiscount',
            targetField: 'documentDiscountAmount',
            decimals: 2
        },
        {
            id: 'calcTotalNetSalesAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'subtract',
            fieldsToOperate: ['totalNetSalesAmountBeforeDiscount', 'documentDiscountAmount'],
            targetField: 'totalNetSalesAmount'
        },
        // Kept for the audit trail, and nothing reads it: VAT is charged on the
        // group below, because a document discount is not known until every line
        // exists and it reduces the taxable base per rate
        {
            id: 'calcTaxAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['itemTaxRate', 'netSalesAmount'],
            targetField: 'taxAmount'
        },
        // Groups the lines by tax id, summing the line nets into each group's
        // taxable base. The tax itself is computed after the discount lands
        {
            id: 'calcVatTaxes',
            logicType: 'calcFields',
            operationType: 'sub.aggregate',
            entityToAggregate: 'lines',
            aggregateBy: ['itemTaxId', 'vatTaxId'],
            targetEntity: 'vatTaxes',
            sumFields: [['netSalesAmount', 'vatTaxableAmountBeforeDiscount']],
            transferFields: [['itemTaxRate', 'vatTaxRate']]
        },
        // The document discount reaches each rate in proportion to its share of
        // the subtotal. Subtracting it from the total instead would charge VAT on
        // part of a zero-rated sale
        {
            id: 'calcDocumentDiscountAllocation',
            logicType: 'calcFields',
            operationType: 'sub.allocate',
            subEntity: 'vatTaxes',
            sourceField: 'documentDiscountAmount',
            weightField: 'vatTaxableAmountBeforeDiscount',
            targetField: 'documentDiscountAmount',
            decimals: 2
        },
        {
            id: 'calcVatTaxableAmount',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'subtract',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmountBeforeDiscount', 'documentDiscountAmount'],
            targetField: 'vatTaxableAmount'
        },
        // VAT, charged on what is left of each rate's base
        {
            id: 'calcVatTaxAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxRate', 'vatTaxableAmount'],
            targetField: 'vatTaxAmount'
        },
        // calculate documentDiscountAmount in Base Currency
        {
            id: 'calcDocumentDiscountAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'divide',
            fieldsToOperate: ['documentDiscountAmount', 'exchangeRate'],
            targetField: 'documentDiscountAmountBaseCurrency'
        },
        // calculate vatTaxAmount in Base Currency
        {
            id: 'calcVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxAmountBaseCurrency'
        },
        // calculate vatTaxableAmount in Base Currency
        {
            id: 'calcVatTaxableAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxableAmountBaseCurrency'
        },
        // calculates totalVatTaxAmount by summing vatTaxAmount on vatTaxes Array
        {
            id: 'calcTotalVatTaxAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmount',
            targetField: 'totalVatTaxAmount'
        },
        // calculates totalVatTaxAmountBaseCurrency by summing vatTaxAmountBaseCurrency on vatTaxes Array
        {
            id: 'calcTotalVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmountBaseCurrency',
            targetField: 'totalVatTaxAmountBaseCurrency'
        },
        // calculates totalNetSalesAmountBaseCurrency by summing taxableAmountBaseCurrency on vatTaxes Array
        {
            id: 'calcTotalNetSalesAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxableAmountBaseCurrency',
            targetField: 'totalNetSalesAmountBaseCurrency'
        },
        // calculates totalGrossSalesAmount by summing up totalVatTaxAmount and totalNetSalesAmount
        {
            id: 'calcTotalGrossSalesAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatTaxAmount', 'totalNetSalesAmount'],
            targetField: 'totalGrossSalesAmount'
        },
        //This calculates the GrossSalesAmount in Base Currency
        {
            id: 'calcTotalGrossSalesAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatTaxAmountBaseCurrency', 'totalNetSalesAmountBaseCurrency'],
            targetField: 'totalGrossSalesAmountBaseCurrency'
        },
        // sets numPayments based on number of entries on the payments array
        {
            id: 'calcNumPayments',
            logicType: 'calcFields',
            operationType: 'condi.setValue',
            targetField: 'numPayments',
            conditionField: 'payments',
            "conditionValueMap": {
                "<=0": 0,
                ">0": "{count}"  // Use a placeholder for the count
            }
        },
        //This ensures that the total of payments is equal to totalGrossSalesAmount 
        {
            id: 'verifyGrossSalesAmountWithPaymentAmount',
            logicType: 'verify',
            operationType: 'sub.checkTotal',
            field: 'totalGrossSalesAmount',
            fxField: 'exchangeRate',
            subEntity: 'payments',
            subEntityField: 'paymentAmount',
            subEntityFieldBaseCurrency: 'paymentAmountBaseCurrency',
            fieldCount: 'numPayments'
        },
        // this resets the Payments array when the totalGrossSalesAmount changes
        // It calculates Installments if paymentSchedule is true
        {
            id: 'calcPayments',
            logicType: 'calcFields',
            operationType: 'sub.calcPayments',
            conditionField: 'totalGrossSalesAmount',
            subEntity: 'payments',
            transferMap: {
                'paymentDate': 'paymentDate',
                'totalGrossSalesAmount': 'paymentAmount',
                'currency': 'paymentCurrency',
                'totalGrossSalesAmountBaseCurrency': 'paymentAmountBaseCurrency'
            }
        },
        // This ensures that payments have a valid id 
        {
            id: 'verifyPaymentId',
            logicType: 'verify',
            operationType: 'sub.checkField',
            subEntity: 'payments',
            subEntityField: 'paymentId',
        },
        // Counts the reverse-charge lines — the booking guard refuses them
        // without a validated VAT ID (validationLogicData.invoice.book)
        {
            id: 'calcReverseChargeLines',
            logicType: 'calcFields',
            operationType: 'header.countWhere',
            subEntity: 'lines',
            where: { field: 'itemTaxRequiresVatId', operator: 'eq', value: true },
            targetField: 'reverseChargeLines'
        },
        //ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    creditNote: [
        // Calculates Net Sales Amount on the Line from the price and quantity on CreditNote Line
        {
            id: 'calcNetSalesAmountBeforeDiscount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['netSalesPrice', 'itemQuantity'],
            targetField: 'netSalesAmountBeforeDiscount'
        },
        // The money the line discount takes off, rounded where it is computed
        {
            id: 'calcLineDiscountAmount',
            logicType: 'calcFields',
            operationType: 'sub.discount',
            subEntity: 'lines',
            typeField: 'discountType',
            valueField: 'discountValue',
            baseField: 'netSalesAmountBeforeDiscount',
            targetField: 'discountAmount',
            decimals: 2
        },
        // netSalesAmount stays the line net that every later step reads -- it is
        // now the amount after any line discount, so a discount reaches the VAT
        // groups and the totals without either of them knowing it exists
        {
            id: 'calcNetSalesAmount',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'subtract',
            subEntity: 'lines',
            fieldsToOperate: ['netSalesAmountBeforeDiscount', 'discountAmount'],
            targetField: 'netSalesAmount'
        },
        // The subtotal: every line's net, after any line discount. This is what
        // the document discount is a percentage of, which is what makes the two
        // levels compose rather than both applying to the list price
        {
            id: 'calcTotalNetSalesAmountBeforeDiscount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'netSalesAmount',
            targetField: 'totalNetSalesAmountBeforeDiscount'
        },
        // The money the document discount takes off, rounded where it is computed
        {
            id: 'calcDocumentDiscountAmount',
            logicType: 'calcFields',
            operationType: 'header.discount',
            typeField: 'documentDiscountType',
            valueField: 'documentDiscountValue',
            baseField: 'totalNetSalesAmountBeforeDiscount',
            targetField: 'documentDiscountAmount',
            decimals: 2
        },
        {
            id: 'calcTotalNetSalesAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'subtract',
            fieldsToOperate: ['totalNetSalesAmountBeforeDiscount', 'documentDiscountAmount'],
            targetField: 'totalNetSalesAmount'
        },
        // Kept for the audit trail, and nothing reads it: VAT is charged on the
        // group below, because a document discount is not known until every line
        // exists and it reduces the taxable base per rate
        {
            id: 'calcTaxAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['itemTaxRate', 'netSalesAmount'],
            targetField: 'taxAmount'
        },
        // Groups the lines by tax id, summing the line nets into each group's
        // taxable base. The tax itself is computed after the discount lands
        {
            id: 'calcVatTaxes',
            logicType: 'calcFields',
            operationType: 'sub.aggregate',
            entityToAggregate: 'lines',
            aggregateBy: ['itemTaxId', 'vatTaxId'],
            targetEntity: 'vatTaxes',
            sumFields: [['netSalesAmount', 'vatTaxableAmountBeforeDiscount']],
            transferFields: [['itemTaxRate', 'vatTaxRate']]
        },
        // The document discount reaches each rate in proportion to its share of
        // the subtotal. Subtracting it from the total instead would charge VAT on
        // part of a zero-rated sale
        {
            id: 'calcDocumentDiscountAllocation',
            logicType: 'calcFields',
            operationType: 'sub.allocate',
            subEntity: 'vatTaxes',
            sourceField: 'documentDiscountAmount',
            weightField: 'vatTaxableAmountBeforeDiscount',
            targetField: 'documentDiscountAmount',
            decimals: 2
        },
        {
            id: 'calcVatTaxableAmount',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'subtract',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmountBeforeDiscount', 'documentDiscountAmount'],
            targetField: 'vatTaxableAmount'
        },
        // VAT, charged on what is left of each rate's base
        {
            id: 'calcVatTaxAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxRate', 'vatTaxableAmount'],
            targetField: 'vatTaxAmount'
        },
        // calculate documentDiscountAmount in Base Currency
        {
            id: 'calcDocumentDiscountAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'divide',
            fieldsToOperate: ['documentDiscountAmount', 'exchangeRate'],
            targetField: 'documentDiscountAmountBaseCurrency'
        },
        // calculate vatTaxAmount in Base Currency
        {
            id: 'calcVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxAmountBaseCurrency'
        },
        // calculate vatTaxableAmount in Base Currency
        {
            id: 'calcVatTaxableAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxableAmountBaseCurrency'
        },
        // calculates totalVatTaxAmount by summing vatTaxAmount on vatTaxes Array
        {
            id: 'calcTotalVatTaxAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmount',
            targetField: 'totalVatTaxAmount'
        },
        // calculates totalVatTaxAmountBaseCurrency by summing vatTaxAmountBaseCurrency on vatTaxes Array
        {
            id: 'calcTotalVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmountBaseCurrency',
            targetField: 'totalVatTaxAmountBaseCurrency'
        },
        // calculates totalNetSalesAmountBaseCurrency by summing taxableAmountBaseCurrency on vatTaxes Array
        {
            id: 'calcTotalNetSalesAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxableAmountBaseCurrency',
            targetField: 'totalNetSalesAmountBaseCurrency'
        },
        // calculates totalGrossSalesAmount by summing up totalVatTaxAmount and totalNetSalesAmount
        {
            id: 'calcTotalGrossSalesAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatTaxAmount', 'totalNetSalesAmount'],
            targetField: 'totalGrossSalesAmount'
        },
        //This calculates the GrossSalesAmount in Base Currency
        {
            id: 'calcTotalGrossSalesAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatTaxAmountBaseCurrency', 'totalNetSalesAmountBaseCurrency'],
            targetField: 'totalGrossSalesAmountBaseCurrency'
        },
        // sets numPayments based on number of entries on the payments array
        {
            id: 'calcNumPayments',
            logicType: 'calcFields',
            operationType: 'condi.setValue',
            targetField: 'numPayments',
            conditionField: 'payments',
            "conditionValueMap": {
                "<=0": 0,
                ">0": "{count}"  // Use a placeholder for the count
            }
        },
        //This ensures that the total of payments is equal to totalGrossSalesAmount
        {
            id: 'verifyGrossSalesAmountWithPaymentAmount',
            logicType: 'verify',
            operationType: 'sub.checkTotal',
            field: 'totalGrossSalesAmount',
            fxField: 'exchangeRate',
            subEntity: 'payments',
            subEntityField: 'paymentAmount',
            subEntityFieldBaseCurrency: 'paymentAmountBaseCurrency',
            fieldCount: 'numPayments'
        },
        // this resets the Payments array when the totalGrossSalesAmount changes
        // It calculates Installments if paymentSchedule is true
        {
            id: 'calcPayments',
            logicType: 'calcFields',
            operationType: 'sub.calcPayments',
            conditionField: 'totalGrossSalesAmount',
            subEntity: 'payments',
            transferMap: {
                'paymentDate': 'paymentDate',
                'totalGrossSalesAmount': 'paymentAmount',
                'currency': 'paymentCurrency',
                'totalGrossSalesAmountBaseCurrency': 'paymentAmountBaseCurrency'
            }
        },
        // This ensures that payments have a valid id
        {
            id: 'verifyPaymentId',
            logicType: 'verify',
            operationType: 'sub.checkField',
            subEntity: 'payments',
            subEntityField: 'paymentId',
        },
        //ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    quote: [
        // Calculates Net Sales Amount on the Line from the price and quantity on Quote Line
        {
            id: 'calcNetSalesAmountBeforeDiscount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['netSalesPrice', 'itemQuantity'],
            targetField: 'netSalesAmountBeforeDiscount'
        },
        // The money the line discount takes off, rounded where it is computed
        {
            id: 'calcLineDiscountAmount',
            logicType: 'calcFields',
            operationType: 'sub.discount',
            subEntity: 'lines',
            typeField: 'discountType',
            valueField: 'discountValue',
            baseField: 'netSalesAmountBeforeDiscount',
            targetField: 'discountAmount',
            decimals: 2
        },
        // netSalesAmount stays the line net that every later step reads -- it is
        // now the amount after any line discount, so a discount reaches the VAT
        // groups and the totals without either of them knowing it exists
        {
            id: 'calcNetSalesAmount',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'subtract',
            subEntity: 'lines',
            fieldsToOperate: ['netSalesAmountBeforeDiscount', 'discountAmount'],
            targetField: 'netSalesAmount'
        },
        // The subtotal: every line's net, after any line discount. This is what
        // the document discount is a percentage of, which is what makes the two
        // levels compose rather than both applying to the list price
        {
            id: 'calcTotalNetSalesAmountBeforeDiscount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'netSalesAmount',
            targetField: 'totalNetSalesAmountBeforeDiscount'
        },
        // The money the document discount takes off, rounded where it is computed
        {
            id: 'calcDocumentDiscountAmount',
            logicType: 'calcFields',
            operationType: 'header.discount',
            typeField: 'documentDiscountType',
            valueField: 'documentDiscountValue',
            baseField: 'totalNetSalesAmountBeforeDiscount',
            targetField: 'documentDiscountAmount',
            decimals: 2
        },
        {
            id: 'calcTotalNetSalesAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'subtract',
            fieldsToOperate: ['totalNetSalesAmountBeforeDiscount', 'documentDiscountAmount'],
            targetField: 'totalNetSalesAmount'
        },
        // Kept for the audit trail, and nothing reads it: VAT is charged on the
        // group below, because a document discount is not known until every line
        // exists and it reduces the taxable base per rate
        {
            id: 'calcTaxAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['itemTaxRate', 'netSalesAmount'],
            targetField: 'taxAmount'
        },
        // Groups the lines by tax id, summing the line nets into each group's
        // taxable base. The tax itself is computed after the discount lands
        {
            id: 'calcVatTaxes',
            logicType: 'calcFields',
            operationType: 'sub.aggregate',
            entityToAggregate: 'lines',
            aggregateBy: ['itemTaxId', 'vatTaxId'],
            targetEntity: 'vatTaxes',
            sumFields: [['netSalesAmount', 'vatTaxableAmountBeforeDiscount']],
            transferFields: [['itemTaxRate', 'vatTaxRate']]
        },
        // The document discount reaches each rate in proportion to its share of
        // the subtotal. Subtracting it from the total instead would charge VAT on
        // part of a zero-rated sale
        {
            id: 'calcDocumentDiscountAllocation',
            logicType: 'calcFields',
            operationType: 'sub.allocate',
            subEntity: 'vatTaxes',
            sourceField: 'documentDiscountAmount',
            weightField: 'vatTaxableAmountBeforeDiscount',
            targetField: 'documentDiscountAmount',
            decimals: 2
        },
        {
            id: 'calcVatTaxableAmount',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'subtract',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmountBeforeDiscount', 'documentDiscountAmount'],
            targetField: 'vatTaxableAmount'
        },
        // VAT, charged on what is left of each rate's base
        {
            id: 'calcVatTaxAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxRate', 'vatTaxableAmount'],
            targetField: 'vatTaxAmount'
        },
        // calculate documentDiscountAmount in Base Currency
        {
            id: 'calcDocumentDiscountAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'divide',
            fieldsToOperate: ['documentDiscountAmount', 'exchangeRate'],
            targetField: 'documentDiscountAmountBaseCurrency'
        },
        // calculate vatTaxAmount in Base Currency
        {
            id: 'calcVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxAmountBaseCurrency'
        },
        // calculate vatTaxableAmount in Base Currency
        {
            id: 'calcVatTaxableAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxableAmountBaseCurrency'
        },
        // calculates totalVatTaxAmount by summing vatTaxAmount on vatTaxes Array
        {
            id: 'calcTotalVatTaxAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmount',
            targetField: 'totalVatTaxAmount'
        },
        // calculates totalVatTaxAmountBaseCurrency by summing vatTaxAmountBaseCurrency on vatTaxes Array
        {
            id: 'calcTotalVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmountBaseCurrency',
            targetField: 'totalVatTaxAmountBaseCurrency'
        },
        // calculates totalNetSalesAmountBaseCurrency by summing vatTaxableAmountBaseCurrency on vatTaxes Array
        {
            id: 'calcTotalNetSalesAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxableAmountBaseCurrency',
            targetField: 'totalNetSalesAmountBaseCurrency'
        },
        // calculates totalGrossSalesAmount by summing up totalVatTaxAmount and totalNetSalesAmount
        {
            id: 'calcTotalGrossSalesAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatTaxAmount', 'totalNetSalesAmount'],
            targetField: 'totalGrossSalesAmount'
        },
        // calculates totalGrossSalesAmountBaseCurrency
        {
            id: 'calcTotalGrossSalesAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatTaxAmountBaseCurrency', 'totalNetSalesAmountBaseCurrency'],
            targetField: 'totalGrossSalesAmountBaseCurrency'
        },
        //ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    purchaseOrder: [
        // Calculates net amount on line from unit price and quantity
        {
            id: 'calcNetAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['unitPrice', 'quantityOrdered'],
            targetField: 'netAmount'
        },
        // Calculates totalNetAmount by summing netAmount of each line
        {
            id: 'calcTotalNetAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'netAmount',
            targetField: 'totalNetAmount'
        },
        // Calculates taxAmount on line from tax rate and net amount
        {
            id: 'calcTaxAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['itemTaxRate', 'netAmount'],
            targetField: 'taxAmount'
        },
        // Aggregates vatTaxes by tax rate from lines
        {
            id: 'calcVatTaxes',
            logicType: 'calcFields',
            operationType: 'sub.aggregate',
            entityToAggregate: 'lines',
            aggregateBy: ['itemTaxId', 'vatTaxId'],
            targetEntity: 'vatTaxes',
            sumFields: [['taxAmount', 'vatTaxAmount'], ['netAmount', 'vatTaxableAmount']],
            transferFields: [['itemTaxRate', 'vatTaxRate']]
        },
        // Calculates vatTaxAmountBaseCurrency per vatTax entry
        {
            id: 'calcVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxAmountBaseCurrency'
        },
        // Calculates vatTaxableAmountBaseCurrency per vatTax entry
        {
            id: 'calcVatTaxableAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxableAmountBaseCurrency'
        },
        // Calculates totalVatAmount by summing vatTaxAmount on the vatTaxes array.
        // Summed from the buckets, not from the lines, so that the header total and
        // its own VAT breakdown are the same number by construction.
        {
            id: 'calcTotalVatAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmount',
            targetField: 'totalVatAmount'
        },
        // Calculates totalVatAmountBaseCurrency from vatTaxes
        {
            id: 'calcTotalVatAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmountBaseCurrency',
            targetField: 'totalVatAmountBaseCurrency'
        },
        // Calculates totalNetAmountBaseCurrency by summing vatTaxableAmountBaseCurrency
        // on the vatTaxes array — the converted buckets, not a conversion of the header.
        {
            id: 'calcTotalNetAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxableAmountBaseCurrency',
            targetField: 'totalNetAmountBaseCurrency'
        },
        // Calculates totalGrossAmount as totalNetAmount + totalVatAmount
        {
            id: 'calcTotalGrossAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalNetAmount', 'totalVatAmount'],
            targetField: 'totalGrossAmount'
        },
        // Calculates totalGrossAmountBaseCurrency by summing the two base-currency
        // totals. Converting totalGrossAmount directly would round independently of
        // them, so the document would not add up in its own base currency.
        {
            id: 'calcTotalGrossAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatAmountBaseCurrency', 'totalNetAmountBaseCurrency'],
            targetField: 'totalGrossAmountBaseCurrency'
        },
        // ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    // Mirrors purchaseOrder; the quantity is itemQuantity, as on the invoice.
    expense: [
        // Line net, VAT and gross from the amount typed on the line (gross or
        // net), or from unit price × quantity while the line is priced
        {
            id: 'calcLineAmounts',
            logicType: 'calcFields',
            operationType: 'sub.grossNet',
            subEntity: 'lines',
            grossField: 'enteredGrossAmount',
            netField: 'enteredNetAmount',
            pricedField: 'pricedNetAmount',
            rateField: 'itemTaxRate',
            quantityField: 'itemQuantity',
            unitPriceField: 'unitPrice',
            targetNetField: 'netAmount',
            targetTaxField: 'taxAmount',
            targetGrossField: 'grossAmount'
        },
        // Calculates totalNetAmount by summing netAmount of each line
        {
            id: 'calcTotalNetAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'netAmount',
            targetField: 'totalNetAmount'
        },
        // Aggregates vatTaxes by tax rate from lines
        {
            id: 'calcVatTaxes',
            logicType: 'calcFields',
            operationType: 'sub.aggregate',
            entityToAggregate: 'lines',
            aggregateBy: ['itemTaxId', 'vatTaxId'],
            targetEntity: 'vatTaxes',
            sumFields: [['taxAmount', 'vatTaxAmount'], ['netAmount', 'vatTaxableAmount']],
            transferFields: [['itemTaxRate', 'vatTaxRate']]
        },
        // Calculates vatTaxAmountBaseCurrency per vatTax entry
        {
            id: 'calcVatTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxAmountBaseCurrency'
        },
        // Calculates vatTaxableAmountBaseCurrency per vatTax entry
        {
            id: 'calcVatTaxableAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'vatTaxes',
            fieldsToOperate: ['vatTaxableAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxableAmountBaseCurrency'
        },
        // What the ledger posts: one bucket per VAT code and expense category
        // (37.02). Same field names as vatTaxes, so postExpense reads either —
        // vatTaxes stays the VAT breakdown the document shows. A line with no
        // category shares a bucket with the other uncategorised lines of its
        // code, and the PURCHASE posting rule gives that bucket its account.
        {
            id: 'calcPostingGroups',
            logicType: 'calcFields',
            operationType: 'sub.aggregate',
            entityToAggregate: 'lines',
            aggregateBy: [['itemTaxId', 'vatTaxId'], ['expenseAccountId', 'expenseAccountId']],
            targetEntity: 'postingGroups',
            sumFields: [['taxAmount', 'vatTaxAmount'], ['netAmount', 'vatTaxableAmount']],
            transferFields: [['itemTaxRate', 'vatTaxRate'], ['expenseAccountIdName', 'expenseAccountIdName']]
        },
        {
            id: 'calcPostingGroupTaxAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'postingGroups',
            fieldsToOperate: ['vatTaxAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxAmountBaseCurrency'
        },
        {
            id: 'calcPostingGroupTaxableAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'sub.basic',
            basicOp: 'divide',
            subEntity: 'postingGroups',
            fieldsToOperate: ['vatTaxableAmount'],
            rootFieldsToOperate: ['exchangeRate'],
            targetField: 'vatTaxableAmountBaseCurrency'
        },
        // Calculates totalVatAmount by summing vatTaxAmount on the vatTaxes array.
        // Summed from the buckets, not from the lines, so that the header total and
        // its own VAT breakdown are the same number by construction.
        {
            id: 'calcTotalVatAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmount',
            targetField: 'totalVatAmount'
        },
        // Calculates totalVatAmountBaseCurrency from vatTaxes
        {
            id: 'calcTotalVatAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxAmountBaseCurrency',
            targetField: 'totalVatAmountBaseCurrency'
        },
        // Calculates totalNetAmountBaseCurrency by summing vatTaxableAmountBaseCurrency
        // on the vatTaxes array — the converted buckets, not a conversion of the header.
        {
            id: 'calcTotalNetAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'vatTaxes',
            fieldsToOperate: 'vatTaxableAmountBaseCurrency',
            targetField: 'totalNetAmountBaseCurrency'
        },
        // Calculates totalGrossAmount as totalNetAmount + totalVatAmount
        {
            id: 'calcTotalGrossAmount',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalNetAmount', 'totalVatAmount'],
            targetField: 'totalGrossAmount'
        },
        // Calculates totalGrossAmountBaseCurrency by summing the two base-currency
        // totals. Converting totalGrossAmount directly would round independently of
        // them, so the document would not add up in its own base currency.
        {
            id: 'calcTotalGrossAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['totalVatAmountBaseCurrency', 'totalNetAmountBaseCurrency'],
            targetField: 'totalGrossAmountBaseCurrency'
        },
        // ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    purchaseRequest: [
        // Calculate estimated amount per line from unit price and requested quantity
        {
            id: 'calcLineEstimatedAmount',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['estimatedUnitPrice', 'requestedQty'],
            targetField: 'lineEstimatedAmount'
        },
        // Sum line estimated amounts into totals.estimatedAmount
        {
            id: 'calcTotalsEstimatedAmount',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'lineEstimatedAmount',
            targetField: 'totals.estimatedAmount'
        },
        // Sum requested quantities across all lines into totals.quantity
        {
            id: 'calcTotalsQuantity',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'requestedQty',
            targetField: 'totals.quantity'
        },
        // Count lines into totals.lines
        {
            id: 'calcTotalsLines',
            logicType: 'calcFields',
            operationType: 'condi.setValue',
            targetField: 'totals.lines',
            conditionField: 'lines',
            conditionValueMap: {
                "<=0": 0,
                ">0": "{count}"
            }
        },
        // Sum requestedQty for sourced lines into totals.sourcedQuantity
        {
            id: 'calcTotalsSourcedQuantity',
            logicType: 'calcFields',
            operationType: 'header.countWhere',
            subEntity: 'lines',
            where: { field: 'supplierId', operator: 'exists' },
            sumField: 'requestedQty',
            targetField: 'totals.sourcedQuantity'
        },
        // Count lines with orderedQty > 0 into totals.orderedLines
        {
            id: 'calcTotalsOrderedLines',
            logicType: 'calcFields',
            operationType: 'header.countWhere',
            subEntity: 'lines',
            where: { field: 'orderedQty', operator: 'gt', value: 0 },
            targetField: 'totals.orderedLines'
        },
        // Sum orderedQty for ordered lines into totals.orderedQuantity
        {
            id: 'calcTotalsOrderedQuantity',
            logicType: 'calcFields',
            operationType: 'header.countWhere',
            subEntity: 'lines',
            where: { field: 'orderedQty', operator: 'gt', value: 0 },
            sumField: 'orderedQty',
            targetField: 'totals.orderedQuantity'
        },
        // ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    stockAdjustment: [
        // Calculates totalProducts by summing up the quantity of each Line
        {
            id: 'calcTotalProducts',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'quantity',
            targetField: 'totalProducts'
        },
        //ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    stockMovement: [
        // Calculates totalProducts by summing up the quantity of each Line
        {
            id: 'calcTotalProducts',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'quantity',
            targetField: 'totalProducts'
        },
        //ensures that nSerie has the correct value
        {
            id: 'calcNSerie',
            logicType: 'calcFields',
            sourceField: 'number',
            operationType: 'serie.calculate',
            targetField: 'nSerie'
        }
    ],
    stockShipment: [
        // Calculates totalProducts by summing up the quantity of each Line
        {
            id: 'calcAllocatedQuantity',
            logicType: 'calcFields',
            operationType: 'header.sumSubLines',
            subEntity: 'lines',
            subSubEntity: 'locations',
            fieldsToOperate: 'quantity',
            targetField: 'allocatedQuantity'
        },
        {
            id: 'calcReservedQuantity',
            logicType: 'calcFields',
            operationType: 'header.sumSubLines',
            subEntity: 'lines',
            subSubEntity: 'locations',
            fieldsToOperate: 'reservedQuantity',
            targetField: 'reservedQuantity'
        },
        {
            id: 'calcTotalProducts',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'itemQuantity',
            targetField: 'totalProducts'
        },
        {
            id: 'calcTotalReservedProducts',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'reservedQuantity',
            targetField: 'totalReservedProducts'
        },
    ],
    customerGroup: [
        {
            id: 'calcSortKey',
            logicType: 'calcFields',
            operationType: 'header.calcField',
            targetField: 'sortKey',
            rules: [
                {
                    id: 'sortKey.child',
                    when: 'parentId != null && id != null',
                    formula: '${parentId}.${id}'
                },
                {
                    id: 'sortKey.parent',
                    when: 'parentId == null && id != null',
                    formula: '${id}'
                }
            ]
        }
    ],
    projectTask: [
        {
            id: 'calcDoneDate',
            logicType: 'calcFields',
            operationType: 'header.calcField',
            targetField: 'doneDate',
            rules: [
                {
                    id: 'doneDateFormula',
                    when: 'status == "done" && doneDate == null',
                    formula: '${now}'
                }
            ]
        }
    ],
    paymentTransaction: [
        {
            id: 'calcAmount',
            logicType: 'calcFields',
            operationType: 'header.findSign',
            targetField: 'amount'
        },
        {
            id: 'calcAmountBaseCurrency',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'divide',
            fieldsToOperate: ['amount', 'exchangeRate'],
            targetField: 'amountBaseCurrency'
        },
        {
            id: 'calcAmountLeft',
            logicType: 'calcFields',
            operationType: 'header.basic',
            basicOp: 'sum',
            fieldsToOperate: ['amount'],
            targetField: 'amountLeft'
        },
        {
            id: 'assignFullyMatched',
            logicType: 'assignFields',
            valueMap: [{ 'fullyMatched': false }]
        },
    ],
    bomVersion: [
        {
            id: 'calcName',
            logicType: 'calcFields',
            operationType: 'header.merge',
            fieldsToMerge: ['productSku', 'version'],
            separator: '-',
            targetField: 'name'
        },
                {
            id: 'calcTotalNetSalesPrice',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['productNetSalesPrice', 'qty'],
            targetField: 'totalNetSalesPrice'
        },
                // Calculates netCost by summing up the totalNetSalesPrice of each Line
        {
            id: 'calcNetCost',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'totalNetSalesPrice',
            targetField: 'netCost'
        },
                {
            id: 'calcTotalGrossSalesPrice',
            logicType: 'calcFields',
            operationType: 'sub.multiply',
            subEntity: 'lines',
            fieldsToOperate: ['productGrossSalesPrice', 'qty'],
            targetField: 'totalGrossSalesPrice'
        },
                // Calculates netCost by summing up the totalNetSalesPrice of each Line
        {
            id: 'calcGrossCost',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'totalGrossSalesPrice',
            targetField: 'grossCost'
        }
    ],
    routingVersion: [
        {
            id: 'calcName',
            logicType: 'calcFields',
            operationType: 'header.merge',
            fieldsToMerge: ['productSku', 'version'],
            separator: '-',
            targetField: 'name'
        },
        {
            id: 'calcInputsCount',
            logicType: 'calcFields',
            operationType: 'sub.countArray',
            subEntity: 'operations',
            subArray: 'inputs',
            targetField: 'inputsCount'
        }
    ],

    // Live header totals while drafting (36.03 rework) — a self-balancing smart line
    // (counterAccountId set) only nets to zero AFTER server-side expansion, into a
    // debit leg AND a credit leg of the same gross amount. Summing its raw
    // debitAmount/creditAmount directly would show e.g. "0 debit / 99 credit" for a
    // one-line smart entry — lopsided-looking even though it posts perfectly
    // balanced. sub.dualAmount computes what each line actually contributes to each
    // side first (gross on both sides when self-balancing, the plain field
    // otherwise), and the sums below total THAT.
    // `balanced` is still deliberately NOT computed here — the server sets
    // `balanced: true` itself once a journal actually posts.
    // Posting rules: two read-only summaries, so a rule can be told apart from
    // its siblings in the list without opening it. Several rules share a type
    // and a priority (every self-accounted PURCHASE rule is PURCHASE / 10), and
    // what actually distinguishes them — the condition, and where they post —
    // is otherwise invisible. Derived on every save so neither can drift from
    // the data it summarises; cloneCoaTemplate runs this same chain, because a
    // cloned rule is inserted directly and never passes through a save.
    postingRule: [
        // The editable rows become the condition the engine reads. Must run
        // before calcMatchText, which describes the result.
        {
            id: 'calcMatch',
            logicType: 'calcFields',
            operationType: 'header.buildCondition',
            sourceArray: 'conditions',
            targetField: 'match'
        },
        {
            id: 'calcMatchText',
            logicType: 'calcFields',
            operationType: 'header.describeCondition',
            sourceField: 'match',
            rowsArray: 'conditions',
            targetField: 'matchText'
        },
        {
            id: 'calcLegsText',
            logicType: 'calcFields',
            operationType: 'header.joinLines',
            array: 'legs',
            fields: ['accountNumber', 'signName'],
            separator: ' + ',
            targetField: 'legsText'
        }
    ],
    journal: [
        {
            id: 'calcLineDualAmount',
            logicType: 'calcFields',
            operationType: 'sub.dualAmount',
            subEntity: 'lines',
            debitField: 'debitAmount',
            creditField: 'creditAmount',
            conditionField: 'counterAccountId',
            targetDebitField: 'effectiveDebitAmount',
            targetCreditField: 'effectiveCreditAmount'
        },
        {
            id: 'calcTotalDebitBase',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'effectiveDebitAmount',
            targetField: 'totalDebitBase'
        },
        {
            id: 'calcTotalCreditBase',
            logicType: 'calcFields',
            operationType: 'header.sumLines',
            subEntity: 'lines',
            fieldsToOperate: 'effectiveCreditAmount',
            targetField: 'totalCreditBase'
        },
        {
            id: 'calcLineCount',
            logicType: 'calcFields',
            operationType: 'condi.setValue',
            conditionField: 'lines',
            targetField: 'lineCount',
            conditionValueMap: { '<=0': 0, '>0': '{count}' }
        }
    ]
}

export default logicData